import { useFeatureFlagEnabled } from 'posthog-js/react'

// Kill switch: defaults ON (fail-open). Only an explicit PostHog `false` hides the gating UX;
// `undefined` (still loading / flag absent) is treated as on.
export function useHipaaGatingEnabled(): boolean {
  return useFeatureFlagEnabled('hipaa-cloud-sync-gating') ?? true
}
